import { combineReducers } from 'redux';
import documentReducer from './documentReducer'; // Create this reducer
import sideBarReducer from './sideBarReducer';

const rootReducer = combineReducers({
  documents: documentReducer,
  sideBar:sideBarReducer
  // add other reducers here
});

export default rootReducer;
